import { useContext } from 'react'
import { XStoreEndowmentContext } from '@/contexts'

export const useXStoreEndowment = () => useContext(XStoreEndowmentContext)
